export default "__VITE_ASSET__CRgj5KkG__"